"use client";

import { LogOut, ShoppingBag, UserIcon } from "lucide-react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useTransition } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { buttonVariants } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useToast } from "@/components/ui/use-toast";
import { useActiveCustomerQuery, activeCustomerQueryKey } from "@/hooks/queries/useActiveCustomerQuery";
import { useScopedI18n } from "@/locales/client";
import { logoutMutation } from "@/actions/mutations/auth";
export const UserButton = () => {
  const {
    data: activeCustomer
  } = useActiveCustomerQuery();
  const queryClient = useQueryClient();
  const t = useScopedI18n("account");
  const router = useRouter();
  const {
    toast
  } = useToast();
  const [isPending, startTransition] = useTransition();
  const handleLogOut = () => {
    startTransition(async () => {
      try {
        const result = await logoutMutation();
        if (result.success) {
          // Invalidate the query to force a refetch
          await queryClient.invalidateQueries({
            queryKey: activeCustomerQueryKey
          });
          router.push("/");
        } else {
          throw new Error("Failed to logout");
        }
      } catch (error) {
        console.error(error);
        toast({
          variant: "destructive",
          title: "Error logging out",
          description: error instanceof Error ? error.message : "Failed to logout"
        });
      }
    });
  };
  return <>
      {activeCustomer ? <DropdownMenu>
          <DropdownMenuTrigger asChild disabled={isPending}>
            <button className={buttonVariants({
          variant: "ghost",
          size: "icon"
        })}>
              <UserIcon className="h-6 w-6" />
              <span className="sr-only">{t("account.title")}</span>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem asChild>
              <Link href="/account">
                <UserIcon className="mr-2 h-4 w-4" />
                <span>{t("account.title")}</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link href="/account/orders">
                <ShoppingBag className="mr-2 h-4 w-4" />
                <span>{t("orders.title")}</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem disabled={isPending} onClick={handleLogOut}>
              <LogOut className="mr-2 h-4 w-4" />
              <span>{isPending ? "Logging out..." : "Log out"}</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu> : <Link className={buttonVariants({
      variant: "ghost",
      size: "icon"
    })} href="/account">
          <UserIcon className="h-6 w-6" />
          <span className="sr-only">Profile</span>
        </Link>}
    </>;
};